import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from 'antd'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import PerSpacer from '../../../components/custom_components/Spacer'
import PerIcon from '../../../components/custom_components/Icon'
import PerText from '../../../components/custom_components/Text'
import { icons } from '../Icon/icons'
import './index.less'

interface TopicCardProps {
  icon?: keyof typeof icons
  heading: string
}

export const TopicCard: FC<TopicCardProps> = ({ icon, heading, children }) => {
  const [t] = useTranslation()

  return (
    <Card bordered={false} style={{ height: '100%' }} className="per-card">
      <PerFlexRow align="middle" direction="column">
        {icon && (
          <PerSpacer mt="m" mb="l">
            <PerIcon variant="decoration" name={icon} color="secondary" size={50} />
          </PerSpacer>
        )}
        <PerText appearance="tile-heading" mb="l">
          {t(heading)}
        </PerText>
        {children}
      </PerFlexRow>
    </Card>
  )
}
